import { render, staticRenderFns } from "./MLabel.vue?vue&type=template&id=225cb866&"
import script from "./MLabel.vue?vue&type=script&lang=js&"
export * from "./MLabel.vue?vue&type=script&lang=js&"
import style0 from "./MLabel.vue?vue&type=style&index=0&id=225cb866&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports